import Content from '../../Content';
import { useSubMenu } from '../../SubMenuContext';
import ColorPicker from '../../ui/ColorPicker/ColorPicker';
import InputNumber from '../../ui/InputNumber';
import ShadowPallete, { type ShadowItem } from '../../ui/ShadowPallete/ShadowPallete';
import { type FAQStyles, useFAQEditor } from './Context/FaqEditorContext';
import Slider from '../../ui/Slider/Slider';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/Select/Select';
import IconPicker from './IconPicker';
import ScrollArea from '../../components/ScrollArea';
import Heading from '../../ui/Heading/Heading';
import { Container } from '../../components/Slots/SlotsComponentes';
import SaveControls from '../../components/Slots/Buttons';

const FaqContent = () => {
	const { setSideBarOpen } = useSubMenu();
	const { changeFaqStyles, faq, changeFaqLayout, onSave } = useFAQEditor();

	const { backgroundColorFaq, perguntaBackgroundColor, corTitulo, corSubtitulo, corPergunta, perguntasGap, borderRadiusFaq, borderRadiusPergunta, borderWidthFaq, borderColorFaq, borderColorResposta, borderWidthResposta, corIcon } = faq.styles as FAQStyles || {};;

	const handleHeaderClick = () => {
		setSideBarOpen(true);
		// toggle('personalizar')
	};

	const handleCorFundo = (cor: string) => {
		changeFaqStyles({ backgroundColorFaq: cor });
	}

	const handleCorFundoPergunta = (cor: string) => {
		changeFaqStyles({ perguntaBackgroundColor: cor });
	}

	const handleCorTitulo = (cor: string) => {
		changeFaqStyles({ corTitulo: cor });
	}

	const handleCorSubtitulo = (cor: string) => {
		changeFaqStyles({ corSubtitulo: cor });
	}

	const handleCorPergunta = (cor: string) => {
		changeFaqStyles({ corPergunta: cor });
	}

	const handlePerguntaGap = (gap: number) => {
		changeFaqStyles({ perguntasGap: gap });
	}

	const handleBorderRadiusFaq = (radius: number) => {
		changeFaqStyles({ borderRadiusFaq: radius });
	}

	const handleBorderRadiusPergunta = (radius: number) => {
		changeFaqStyles({ borderRadiusPergunta: radius });
	}

	const changeShadow = (sombra: ShadowItem) => {
		changeFaqStyles({ shadowFaq: sombra });
	}

	const handleBorderWidthFaq = (width: number) => {
		changeFaqStyles({ borderWidthFaq: width });
	}

	const handleBorderColorFaq = (color: string) => {
		changeFaqStyles({ borderColorFaq: color });
	}

	const handleBorderColorFaqResposta = (color: string) => {
		changeFaqStyles({ borderColorResposta: color });
	}

	const handleBorderWidthResposta = (width: number) => {
		changeFaqStyles({ borderWidthResposta: width });
	}

	const handleBorderStyleFaq = (style: 'solid' | 'dashed' | 'dotted') => {
		changeFaqStyles({ borderStyleFaq: style });
	}

	const handleBorderStyleResposta = (style: 'solid' | 'dashed' | 'dotted') => {
		changeFaqStyles({ borderStyleResposta: style });
	}

	const handleCorIcon = (cor: string) => {
		changeFaqStyles({ corIcon: cor });
	}

	const handleLayoutChange = (layout: string) => {
		changeFaqLayout(layout);
	}

	const salvar = () => {
		onSave();
	}

	return (
		<Content id='faq-editor'>
			<ScrollArea>

				<Heading header='Editar FAQ' onClick={handleHeaderClick} />

				<Container opened>
					<Container.Trigger title='Editar Estilos do FAQ' />
					<Container.Slot>
						<div>
							<ColorPicker align={'start'} side='bottom' sideOffset={20} color={corTitulo || '#000'} onChange={handleCorTitulo} placeholder='Cor do título' />
							<ColorPicker align={'start'} side='bottom' sideOffset={20} color={corSubtitulo || '#1f2937'} onChange={handleCorSubtitulo} placeholder='Cor do subtítulo' />

							<ColorPicker align={'start'} side='bottom' sideOffset={20} color={backgroundColorFaq || '#fff'} onChange={handleCorFundo} placeholder='Cor do fundo geral' />
							<ColorPicker align={'start'} side='bottom' sideOffset={20} color={perguntaBackgroundColor || '#fff'} onChange={handleCorFundoPergunta} placeholder='Cor do fundo das perguntas' />

							<ColorPicker align={'start'} side='bottom' sideOffset={20} color={corPergunta || '#000'} onChange={handleCorPergunta} placeholder='Cor do texto das perguntas' />

							<ColorPicker align={'start'} side='bottom' sideOffset={20} color={corIcon || '#000'} onChange={handleCorIcon} placeholder='Cor do ícone' />
						</div>

						<Container.Label>Tipo de layout</Container.Label>
						<Select onValueChange={handleLayoutChange}>
							<SelectTrigger>
								<SelectValue placeholder='Escolha um layout' />
							</SelectTrigger>
							<SelectContent >
								<SelectItem value='accordion'>
									Padrão Faq
								</SelectItem>
								<SelectItem value='grade'>
									Grade
								</SelectItem>
								<SelectItem value='lista'>
									Lista
								</SelectItem>
								<SelectItem value='abas'>
									Abas
								</SelectItem>
							</SelectContent>
						</Select>

						<Container.Label>Espaçamento entre perguntas</Container.Label>
						<InputNumber defaultValue={perguntasGap === undefined ? 8 : perguntasGap} min={0} max={45} onChange={handlePerguntaGap} />

					</Container.Slot>
				</Container>

				<Container>
					<Container.Trigger title='Alterar borda do FAQ' />
					<Container.Slot>
						<ColorPicker align={'start'} side='bottom' sideOffset={20} color={borderColorFaq || '#000'} onChange={handleBorderColorFaq} placeholder='Cor da borda' />
						<Container.Label>Tipo da borda</Container.Label>
						<Select onValueChange={handleBorderStyleFaq}>
							<SelectTrigger>
								<SelectValue placeholder='Escolha uma borda' />
							</SelectTrigger>
							<SelectContent >
								<SelectItem value='solid'>
									Solida
								</SelectItem>
								<SelectItem value='dashed'>
									Tracejada
								</SelectItem>
								<SelectItem value='dotted'>
									Pontilhada
								</SelectItem>
							</SelectContent>
						</Select>

						<Container.Label placeholder={`${borderWidthFaq || 0}px`}>Tamanho da borda</Container.Label>
						<Slider defaultValue={borderWidthFaq} value={borderWidthFaq} min={0} max={10} onChange={(_, valor) => handleBorderWidthFaq(Array.isArray(valor) ? valor[0] : valor)} className='w-[calc(100%-10px)] m-auto py-[10px]' />

						<Container.Label>Raio da borda do FAQ</Container.Label>
						<InputNumber label='px' defaultValue={borderRadiusFaq} min={0} max={45} onChange={handleBorderRadiusFaq} />


					</Container.Slot>

				</Container>

				<Container>
					<Container.Trigger title='Alterar borda das respostas' />
					<Container.Slot>
						<ColorPicker align={'start'} side='bottom' sideOffset={20} color={borderColorResposta || '#000'} onChange={handleBorderColorFaqResposta} placeholder='Cor da borda' />

						<Container.Label>Tipo da borda</Container.Label>
						<Select onValueChange={handleBorderStyleResposta}>
							<SelectTrigger>
								<SelectValue placeholder='Escolha uma borda' />
							</SelectTrigger>
							<SelectContent >
								<SelectItem value='solid'>
									Solida
								</SelectItem>
								<SelectItem value='dashed'>
									Tracejada
								</SelectItem>
								<SelectItem value='dotted'>
									Pontilhada
								</SelectItem>
							</SelectContent>
						</Select>
						<Container.Label placeholder={`${borderWidthResposta || 0}px`}>Tamanho da borda</Container.Label>
						<Slider defaultValue={borderWidthResposta} value={borderWidthResposta} min={0} max={10} onChange={(_, valor) => handleBorderWidthResposta(Array.isArray(valor) ? valor[0] : valor)} className='w-[calc(100%-10px)] m-auto py-[10px]' />

						<Container.Label>Raio da borda das perguntas</Container.Label>
						<InputNumber label='px' defaultValue={borderRadiusPergunta} min={0} max={40} onChange={handleBorderRadiusPergunta} />

					</Container.Slot>

				</Container>

				<Container>
					<Container.Trigger title='Escolher Sombra' />
					<Container.Slot>
						<ShadowPallete onChoose={changeShadow} />
					</Container.Slot>
				</Container>

				<Container>
					<Container.Trigger title='Escolher ícone' />
					<Container.Slot>
						<IconPicker />
					</Container.Slot>
				</Container>

				<SaveControls onSave={salvar} />

			</ScrollArea>
		</Content>
	);
};

export default FaqContent;
